import SearchIcon from '@material-ui/icons/Search';
import { createFrontendModule, FrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import searchPlugin from '@backstage/plugin-search/alpha';

const customSearchPage = PageBlueprint.makeWithOverrides({
  factory(originalFactory) {
    return originalFactory({
      path: '/search',
      routeRef: searchPlugin.routes.root,
      title: 'Search',
      icon: <SearchIcon fontSize="inherit" />,
      loader: async () => {
        const { searchPage: content } = await import('./SearchPage');
        return (
          <SearchContextProvider>
            {content}
          </SearchContextProvider>
        );
      },
    });
  },
});

export const searchPageModule: FrontendModule = createFrontendModule({
  pluginId: 'search',
  extensions: [customSearchPage],
});
